import Phaser from 'phaser'
import ScoreLabel from './ScoreLabel'

export default class level2 extends Phaser.Scene
{
    constructor()
    {
        super('level-2')
    }

    init(data)
    {
        this.platforms = undefined
        this.player = undefined
        this.navLeft = undefined
        this.navRight = undefined
        this.movingPlatform = undefined 
        this.trap = undefined
        this.diamond = undefined
        this.diamonds = undefined
        this.score = data.score
        this.scoretext =undefined
        this.checkPoint = undefined

    }

    preload()
    {
        this.load.image('background', 'images/Green.png')
        this.load.image('platform1', 'images/Off.png')
        this.load.image('platform2', 'images/Grey Off.png')
        this.load.spritesheet('playerIdl', 'images/Virtual Guy/Idle.png', {frameHeight: 32, frameWidth:32})
        this.load.image('playerJmp', 'images/Virtual Guy/Jump.png')
        this.load.spritesheet('CheckPoint', 'images/Checkpoint/Checkpoint-flag.png', {frameHeight:64 , frameWidth:64} )
        this.load.image('diamond', 'images/Collectible/diamond_big.png')
        this.load.image('diamonds', 'images/Collectible/diamond_big.png')
        this.load.image('right-btn', 'images/right-btn.png')
        this.load.image('left-btn', 'images/left-btn.png')
        this.load.image('movingPlatform', 'images/Brown Off.png')
    }

    create()
    {
        this.add.image(240, 320, 'background').setScale(10)
        this.createButton()
      
        this.ScoreLabel = this.createScoreLabel(20, 20, this.score)
       
        this.player = this.physics.add.sprite(300, 400, 'playerIdl').setScale(2)
        this.player.body.checkCollision.up = false
        this.player.body.checkCollision.left = false
        this.player.body.checkCollision.right = false

       this.platforms = this.physics.add.staticGroup()
       this.platforms.create(300, 500, 'platform1').setScale(2.6)
       this.platforms.create(150, 400, 'platform1').setScale(2.6) 
       this.platforms.create(400, 180, 'platform1').setScale(2.6)
       this.platforms.create(240, 100, 'platform1').setScale(2.6)

       this.trap = this.physics.add.staticGroup()
       this.trap.create(80, 180, 'platform1').setScale(2.6)

        this.movingPlatform = this.physics.add.sprite(150, 300, 'movingPlatform')
                .setScale(2.6).setImmovable(true)
        // @ts-ignore
        this.movingPlatform.body.allowGravity = false;
        this.movingPlatform.setBounce(1);
        this.physics.add.collider(this.movingPlatform, this.player)

        this.tweens.add({
            targets: this.movingPlatform,
            duration: 2000,
            x: 350,
            loop: -1,
            yoyo: true,
        });
       this.physics.add.collider(this.movingPlatform, this.player)
       this.physics.add.collider(this.player, this.platforms)


       this.diamond = this.physics.add.group()
        this.diamond.create(300, 470, 'diamond').setScale(1.5).setOffset(0,5)
        this.diamond.create(150, 380, 'diamond').setScale(1.5).setOffset(0,5)
        this.diamond.create(400, 150, 'diamond').setScale(1.5).setOffset(0,5)
        this.physics.add.collider(this.platforms, this.diamond)

        this.diamonds = this.physics.add.group()
        this.diamonds.create(80, 150, 'diamonds').setScale(1.5).setOffset(0,5)
        this.physics.add.collider(this.trap, this.diamonds)


        this.checkPoint = this.physics.add.sprite(240, 50, 'CheckPoint').setOffset(0,5)
        this.physics.add.collider(this.platforms, this.checkPoint)
        this.anims.create({
            key: 'flag',
            frames: this.anims.generateFrameNumbers('checkpoint',{
                start: 0, end: 9
            }),
            frameRate:10
        })

        this.physics.add.overlap(
            this.player,
            this.diamond,
            this.handleCollectDiamond,
            undefined,
            this
        )

        this.physics.add.overlap(
            this.player,
            this.checkPoint,
            this.nextLevel3,
            undefined,
            this
        )
       
    }

    update()
    {

        const touchingDown = this.player.body.touching.down

        if(touchingDown)
        { 
            this.player.setVelocityY(-220)
            this.player.setTexture('playerJmp')
            this.sound.play('jumpsound')
            var soundconfig = {
                volume: 0.3
            }
        }
        const vy = this.player.body.velocity.y
        if(vy > 0&& this.player.texture.key !== 'playerIdl')
        {
            this.player.setTexture('playerIdl')
        } else if( this.navLeft){
            this.player.setFlipX(true)
            this.player.setVelocityX(-150)
        } else if (this.navRight){
            this.player.setFlipX(false)
            this.player.setVelocityX(150)
        } else {
            this.player.setVelocityX(0)
        }

        this.checkPoint.anims.play('flag', true)

        
        if(this.player.y>630){
            this.scene.start('game-over-scene', {score: this.ScoreLabel.getScore()})
            this.sound.stopAll()
        }
       
    }
    
    createButton()
    {
        this.input.addPointer(2)

        let navLeft = this.add.image(50, 570, 'left-btn')
        .setInteractive()
        .setDepth(1)

        let navRight = this.add.image(430, 570, 'right-btn')
        .setInteractive()
        .setDepth(1)

        navLeft.on('pointerdown', () => {
            this.navLeft = true},this)
            navLeft.on('pointerout', () =>{
                this.navLeft=false}, this)

        navRight.on('pointerdown', () =>{
            this.navRight = true}, this)
            navRight.on('pointerout', () =>{
                this.navRight = false}, this)
    }

    handleCollectDiamond(player, diamond)
    {
        this.diamond.killAndHide(diamond)
        this.physics.world.disableBody(diamond.body)

        this.ScoreLabel.add(5)
    }

    createScoreLabel(x, y, Score)
    {
        const style = {fontSize: '20px', fill:'#000'}
        const label = new ScoreLabel(this, x, y, Score, style).setDepth(1)

        this.add.existing(label)

        return label
    }

    nextLevel3()
    {
        this.scene.start('level-3', {score: this.ScoreLabel.getScore()})
    }
}